import { Table } from '@/components/Bicester';
import { PopoverWrapper } from '@/components/Bicester/PopoverWrapper';
import { Cell } from '@/components/Bicester/Table';
import { LevelCell, UserNameCell } from '@/components/Bicester/Table/Cells';
import React from 'react';

const ExpiredTicketTable = ({
  data,
  page,
  total,
  onChange,
  loading,
}: {
  data: any[];
  page: number;
  total: number;
  onChange: (params: any) => void;
  loading?: boolean;
}) => {
  return (
    <Table
      pageInfo={{ page, total }}
      data={data}
      loading={loading}
      columns={[
        {
          columnProps: {
            flexGrow: 2,
          },
          header: '卡券号',
          cell: <Cell dataKey="ticket_id" />,
        },
        {
          columnProps: {
            flexGrow: 1,
          },
          header: '客户名',
          cell: <UserNameCell dataKey="user_name" />,
        },
        {
          columnProps: {
            flexGrow: 1.5,
          },
          header: '手机号',
          cell: <Cell dataKey="phone" />,
        },
        {
          columnProps: { flexGrow: 1 },
          header: '会员等级',
          cell: <LevelCell dataKey="level" />,
        },
        {
          columnProps: {
            flexGrow: 5,
          },
          header: '卡券名/卡券所属活动',
          cell: (
            <Cell>
              {(rowData) => (
                <PopoverWrapper
                  popover={{
                    content: (
                      <div className="text-[#455255]">
                        {rowData?.coupons_name && <div>{rowData?.coupons_name}</div>}
                        {rowData?.ticket_act_name && <div>活动：{rowData?.ticket_act_name}</div>}
                      </div>
                    ),
                  }}
                >
                  <div className="multiline-cell-content-wrap">
                    {rowData?.coupons_name && (
                      <div className="multiline-cell-content">{rowData?.coupons_name}</div>
                    )}
                    {rowData?.ticket_act_name && (
                      <div className="multiline-cell-content">活动：{rowData?.ticket_act_name}</div>
                    )}
                  </div>
                </PopoverWrapper>
              )}
            </Cell>
          ),
        },
        {
          columnProps: {
            flexGrow: 2,
          },
          header: '卡券有效期',
          cell: (
            <Cell>
              {(rowData) => (
                <div className="multiline-cell-content-wrap">
                  <div className="multiline-cell-content">开始{rowData?.start_at ?? '--'}</div>
                  <div className="multiline-cell-content">结束{rowData?.end_at ?? '--'}</div>
                </div>
              )}
            </Cell>
          ),
        },
        {
          columnProps: {
            flexGrow: 1,
          },
          header: '状态',
          cell: <Cell dataKey="status">已过期</Cell>,
        },
      ]}
      onChange={onChange}
    >
      <Table.Body height={289} rowHeight={64} />
      <Table.Pagination style={{ ...(total === 0 && { visibility: 'hidden' }) }} />
    </Table>
  );
};

export default ExpiredTicketTable;
